import { Link } from "react-router-dom";
import ControlsEvolutionMiniChart from "../components/ControlsEvolutionMiniChart";
import TopModelsWeeklyMiniList from "../components/TopModelsWeeklyMiniList";
import TopShopsWeeklyMiniList from "../components/TopShopsWeeklyMiniList";

function DashboardPage() {
    return (
        <section>
            <h1 className="h4 mb-2">Tableau de bord</h1>
            <p className="text-secondary mb-4">Toutes les informations importantes en un coup d'œil.</p>

            
            <div className="row g-3">
                <div className="col-12 col-md-6 col-xl-4">
                    <div className="card shadow-sm">
                        <div className="card-body">
                            <h2 className="h6 mb-2 border-bottom pb-1 mb-3">Contrôles</h2>
                            <div className="mb-3">
                                <ControlsEvolutionMiniChart />
                            </div>
                            <Link className="btn btn-primary btn-sm" to="/controls">Ouvrir</Link>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-6 col-xl-4">
                    <div className="card shadow-sm">
                        <div className="card-body">
                            <h2 className="h6 mb-2 border-bottom pb-1 mb-3">Véhicules</h2>
                            <div className="mb-3">
                                <TopModelsWeeklyMiniList />
                            </div>
                            <Link className="btn btn-primary btn-sm" to="/cars">Ouvrir</Link>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-6 col-xl-4">
                    <div className="card shadow-sm">
                        <div className="card-body">
                            <h2 className="h6 mb-2 border-bottom pb-1 mb-3">Ateliers</h2>
                            <div className="mb-3">
                                <TopShopsWeeklyMiniList />
                            </div>
                            <Link className="btn btn-primary btn-sm" to="/shops">Ouvrir</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default DashboardPage;
